import { annotations } from '@esentai/core/features/reconciliationReceiptBonusDetails/serializer';

import { createPageSerializer } from '@/serializers';

export default createPageSerializer({
  ...annotations,
});
